export default "__VITE_ASSET__DMYl58yY__"